export const labels = {
	title: {
		label: "Label.MobileCreator.RemovePhotoConfirmDialog.Title",
		default: "Remove photos",
	},
	ok: {
		label: "Label.MobileCreator.RemovePhotoConfirmDialog.Ok",
		default: "Remove",
	},
	cancel: {
		label: "Label.MobileCreator.RemovePhotoConfirmDialog.Cancel",
		default: "Cancel",
	},
	message: {
		label: "Label.MobileCreator.RemovePhotoConfirmDialog.Message",
		default:
			"Do you want to remove {0} photos from your selection of which {1} from your product?",
	},
} as const;
